<template>
    <div class="Proyecto">
        
        <!--Card loading-->
        <div class="card" v-if="loading">
            <div>
                <div class="card-body">
                    <div class="d-flex justify-content-center mt-2">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Cuerpo Principal-->
        <div class="card" v-else>
            <div class="card-body">
                <h3>Proyecto {{nombre}}</h3>
                <hr>
                <div class="row">
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-4">
                                <img :src="getUrl(avatar)" class="img">
                            </div>
                            <div class="col-sm-8">
                                <router-link :to="{ name: 'calificacion', params: {id: idEmpresa}}">
                                    <p>@{{nombreUsr}}
                                        <img :src="getBandera(pais)" class="bandera">
                                    </p>
                                </router-link>
                                <p><star-rating :increment="0.1" :rating="makeNumber(rating)" :star-size="20" :show-rating="false" :read-only="true"/></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <b>Fecha Publicacion:</b> {{fechaFormat(fechaPublicacion)}} <br> 
                        <b>Fecha Inicio:</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{fechaFormat(fechaInicio)}} <br>
                        <b>Fecha Entrega:</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{fechaFormat(fechaCierre)}} <br>
                        <b>Idioma Principal:</b> &nbsp;&nbsp;&nbsp;{{idioma}} <br>
                        <b v-if="idioma2 != ''">Segundo idioma:</b> &nbsp;&nbsp; {{idioma2}}
                    </div>
                    <div class="col-sm-2">
                        <b>Producto:</b> {{producto}} <br>
                        <b>Version:</b> {{version}}
                    </div>
                    <div class="col-sm-3">
                        <h6><b>Conocimientos Requeridos:</b></h6>
                        <span class="badge badge-success">{{findEsp(esp1)}}</span>
                        <span class="badge badge-success">{{findEsp(esp2)}}</span>
                        <span class="badge badge-success">{{findEsp(esp3)}}</span>
                    </div>
                </div>

                <div class="row pt-1">
                    <div class="col-sm-8">
                        <span class="badge badge-dark">Descripción</span>
                        <p>{{cuerpo}}</p>
                    </div>
                    
                    <div class="col-sm-4">
                        <span class="badge badge-dark">Experiencia Adicional</span>
                        <p v-if="otroRequerimiento.length > 0">{{otroRequerimiento}}</p>
                        <p v-else>
                            <i>No especificado</i>
                        </p>
                        
                    </div>
                </div>
                
                
            </div>

            <div class="card-footer">
                <p class="pointer" v-if="adjunto.length > 0">
                    Adjunto: <font-icon class="pdf" icon="file-pdf" @click="descargarFile(adjunto)"/>
                </p>
                <p v-else>
                    Sin Adjunto
                </p>
            </div>
        </div>
        
    </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'

export default {
name:'Propuestas',
mixins: [ globalFunctions ],
components:{ StarRating },
props:['idProyecto'],
data(){
    return(
        {
        idEmpresa: '',
        nombre:'',
        nombreUsr:'',
        rating: 0,
        avatar:'',
        adjunto: '',
        cuerpo:'',
        esp:[],
        comments:[],
        esp1: '',
        esp2: '',
        esp3: '',
        rutaAdjunto:'',
        rol: localStorage.rol,
        propuestasCons: [],
        sesion: false,
        fechaInicio: '',
        fechaPublicacion: '',
        fechaCierre: '',
        pais: '',
        idioma: '',
        idioma2: '',
        producto :'',
        version: '',
        otroRequerimiento: '',
        loading: false
        }
    )
},
methods:{

getData(){
    this.loading = true;

    let data = {
        flag:1,
        id:this.idProyecto
    }

    this.axios.post(this.url + 'consultasBasicas.php', {flag:1}).then((responce) =>{
        this.esp = responce.data;
    });

    this.axios.post(this.url + 'getProyectos.php', data).then((responce) =>{
        this.loading = false;
        this.nombre = responce.data[0].titulo_proyecto;
        this.cuerpo = responce.data[0].cuerpo;
        this.rutaAdjunto = responce.data[0].adjunto_original;
        this.adjunto = responce.data[0].adjunto;
        this.esp1 = responce.data[0].esp1;
        this.esp2 = responce.data[0].esp2;
        this.esp3 = responce.data[0].esp3;
        this.nombreUsr = responce.data[0].usuario;
        this.avatar = responce.data[0].avatar;
        this.url = this.url + this.rutaAdjunto;
        this.rating = responce.data[0].estrellas;
        this.idEmpresa = responce.data[0].id_empresa;
        this.fechaInicio = responce.data[0].fecha_inicio;
        this.idioma = responce.data[0].idioma;
        this.idioma2 = responce.data[0].idioma_dos;
        this.producto = responce.data[0].producto;
        this.version = responce.data[0].version;
        this.fechaPublicacion = responce.data[0].fecha;
        this.fechaCierre = responce.data[0].fecha_cierre;
        this.otroRequerimiento = responce.data[0].notaExperiencia;
        this.pais = responce.data[0].pais_region;
    }) 
},
findEsp(value){
    for (var i=0; i < this.esp.length; i++) {
        if (this.esp[i].id_modulo === value) {
            return this.esp[i].module_cod + " - " + this.esp[i].module_name;
        }
    }
}
},


created(){
    this.getData()
},

computed:{
    ...mapState(['url'])
},


}
</script>


<style scoped>
.card-header{
    background-color: white;
}

.card-footer{
    background-color: white;
}

.img{
    width: 50px;
    height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/Proyecto.vue